import { render, staticRenderFns } from "./PsPatientBtnNewMedication.vue?vue&type=template&id=39362230&scoped=true&"
import script from "./PsPatientBtnNewMedication.vue?vue&type=script&lang=js&"
export * from "./PsPatientBtnNewMedication.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientBtnNewMedication.vue?vue&type=style&index=0&id=39362230&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39362230",
  null
  
)

export default component.exports